import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import VehiclesOverview from './VehiclesOverview';

const AllVehiclesOverview = ({ match, t }) => (
  <VehiclesOverview
    pageTitle={t('allVehicles')}
    baseUrl="/all-vehicles"
    matchParams={match.params}
    noAddVehicle
    showCreatedBy
  />
);

AllVehiclesOverview.propTypes = {
  t: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
};

export default compose(withTranslation())(AllVehiclesOverview);
